class PageModal extends DetailsModal {
    constructor() {
        super();

        this.modalContent = this.querySelector('.modal__content');
        this.modalHeading = this.querySelector('.page-modal__heading');
        this.modalBody = this.querySelector('.page-modal__body');
        if (this.modalContent.dataset.handle) {
            fetch(`/pages/${this.modalContent.dataset.handle}.json`)
                .then((blob) => blob.json())
                .then(({ page }) => {
                    this.modalHeading.innerText = page.title ?? '';
                    this.modalBody.innerHTML = page.body_html ?? '';
                });
        };

        if (this.querySelector('input[aria-invalid="true"]')) {
            this.open = (event) => {
                this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
                event.target.closest('details').setAttribute('open', true);
                document.body.addEventListener('click', this.onBodyClickEvent);
                document.body.classList.add('overflow-hidden');
            }
        }
    }

    open(event) {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');
    }
  
    close(focusToggle = true) {
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }
}

customElements.define('page-modal', PageModal);
